import { makeStyles } from '@fluentui/react-components';
import { tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
    tableCellHeader: {
        paddingBottom: tokens.spacingVerticalM,
        minHeight: 'max-content',
        height: 'max-content',
        fontSize: tokens.fontSizeBase200,
        lineHeight: tokens.fontSizeBase200,
        color: tokens.colorNeutralForegroundDisabled,
    },
});
